<template>
  <ValidationProvider ref="cityProvider" :name="$attrs['name'] || 'city'" rules="required" v-slot="{ errors }">
    <label for="inputEmail4" class="pb-2">{{ label }}</label>
    <v-select :items="cities" v-model="selectedCity" @change="validateControl" @blur="validateControl" item-text="name"
      item-value="id" label="اختر المدينة" solo :error-messages="errors"></v-select>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import LookupService from '@/services/lookup.service';
import { City } from '@/models/lookup.model';

@Component({
  diProvide: [
    LookupService,
  ],
})
export default class CityComponent extends Vue {
  @Inject(LookupService) public lookupService!: LookupService;

  @Prop({ default: 50 }) length!: number;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: 'الرجاء ملء الحقل' }) placeholder!: string;
  @Prop({ default: '' }) label!: string;
  @Prop({ default: '' }) city!: string;
  isFieldValid: any = 1;
  selectedCity = 0;
  cities = [] as City[];

  async mounted() {
    const response = await this.lookupService.getCities();

    if (response.result) {
      this.cities = response.result.filter((c) => c.countryId === 1);
    }

    if (this.city !== '') {
      const filteredCityid = this.cities?.find((x) => x.name === this.city)?.id;
      if (filteredCityid) {
        this.selectedCity = filteredCityid;
      }
    }
  }

  validateControl() {
    this.isFieldValid = true;
    if (this.selectedCity === 0) {
      this.isFieldValid = false;
    }
    this.$emit('controlDataChanged', { value: this.cities.find((x) => x.id === this.selectedCity)?.name, index: this.index, isValid: this.isFieldValid });
  }
}
</script>
